function findScrollRoot(obj: HTMLElement): HTMLElement | null {
  let parent = obj.parentElement;
  while (parent) {
    const overflow = getComputedStyle(parent).overflow;
    //TODO there is maybe something to do with overflow-x overflow-y
    if (['auto', 'scroll', 'overlay'].includes(overflow)) {
      return parent;
    }
    parent = parent.parentElement;
  }
  return null;
}

export function show(node: HTMLElement, zIndex?: number): HTMLElement {
  // Handle jQuery objects
  const obj = node;

  if (!obj) {
    console.error('blackveil.show: invalid node', node);
    return null;
  }

  const zRoot = obj.parentElement;
  if (!zRoot) {
    console.error('blackveil.show: node has no parent', obj);
    return null;
  }

  const scrollRoot = findScrollRoot(obj);
  const computedStyle = getComputedStyle(obj);
  const data = {
    zIndex: computedStyle.zIndex,
    position: computedStyle.position
  };

  zIndex = zIndex || 2;

  if (computedStyle.position === 'static') {
    obj.style.position = 'relative';
  }
  obj.style.zIndex = String(zIndex + 1);

  zRoot.insertAdjacentHTML('beforeend', `<div class='fw-blackveil' style='display:block;z-index:${zIndex}'></div>`);
  const theVeil = zRoot.lastElementChild as HTMLElement;

  theVeil.addEventListener('mousewheel', function(origEvt: any) {
    if (scrollRoot) {
      scrollRoot.scrollBy(-origEvt.wheelDeltaX, -origEvt.wheelDeltaY);
    }
  }, { passive: true });

  theVeil.setAttribute('data-veil', JSON.stringify(data));
  theVeil.addEventListener('click', ev => ev.stopPropagation());
  return theVeil;
}

export function hide(node: HTMLElement): HTMLElement | null {
  if (!node) return null;

  const obj = node;
  const zRoot = obj.parentElement;
  if (!zRoot) return null;

  const veils = Array.from(zRoot.querySelectorAll('.fw-blackveil'));
  const theVeil = veils[veils.length - 1] as HTMLElement;

  if (!theVeil) return null;

  const dataStr = theVeil.getAttribute('data-veil');
  if (dataStr) {
    const data = JSON.parse(dataStr);
    obj.style.zIndex = data.zIndex;
    setTimeout(function() { obj.style.position = data.position; }, 500); //at the end of the animation
  } else {
    //FIXME it happen
    // when we quit the home with the activity form
  }
  theVeil.remove();
  return theVeil;
}
